import { withChartLayout } from 'components/common';
import NutritionOrderEntry from 'components/features/chart/order-entry/nutrition/NutritionOrderEntry';

const NutritionPage = withChartLayout('Nutrition')(NutritionOrderEntry);
export default NutritionPage;
